<template>
  <div class="Audio">
    <audio :id="audioId" :src="src" loop="true"></audio>
    <p class="Audio-text" @click="toggleAudio">{{ isPlaying ? 'Mute' : 'Unmute' }}</p>
    <div class="Audio--controller ButtonIcon ButtonIcon--transparent" @click="toggleAudio()">
      <transition name="fade" mode="out-in">
        <icon name="volume-up" v-if="isPlaying" :key="'on'"></icon>
        <icon name="volume-off" v-else :key="'off'"></icon>
      </transition>
    </div>
  </div>
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/volume-off'
import 'vue-awesome/icons/volume-up'
import MixinHelper from './../mixins/helper'
export default {
  components: {
    Icon
  },

  props: ['src'],

  mixins: [ MixinHelper ],

  data () {
    return {
      isPlaying: false,
      audioId: null
    }
  },

  computed: {
    audio () {
      return this.getAudio(this.audioId)
    }
  },

  methods: {
    getAudio (el) {
      return document.getElementById(el)
    },

    increaseVolume () {
      let vm = this
      let timer = setInterval(() => {
        if (vm.audio.volume < 0.9) {
          vm.audio.volume += 0.01
        } else {
          clearTimeout(timer)
        }
      }, 50)
    },

    initAudio () {
      this.audio.volume = 0
      this.audio.play()
      this.increaseVolume()
    },

    toggleAudio () {
      if (this.isPlaying) {
        this.audio.pause()
      } else {
        this.audio.play()
      }
    }
  },

  created () {
    this.audioId = this.generateKey()
  },

  mounted () {
    this.audio.addEventListener('play', () => {
      this.isPlaying = true
    })
    this.audio.addEventListener('pause', () => {
      this.isPlaying = false
    })
  }
}
</script>

<style lang="scss" scoped>
@import './../../assets/_variables.scss';

.Audio {
  align-items: center;
  background-color: $transparentGray;
  border-radius: 100px;
  display: flex;
  justify-content: space-around;
  position: fixed;
  bottom: 25px;
  right: 25px;
  width: 120px;
  z-index: 1000;
}

.Audio-text {
  color: $offwhite;
  cursor: pointer;
  font-family: $fontSansSerif;
  font-size: 16px;
  margin: 0 0 0 16px;
  transition: $transitionHover;
  &:hover {
    color: $gold;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/partials/audio.vue